import React, { useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import StatusFurnace from "../components/StatusFurnace";
import Context from "../../context/Context";
import WebsocketContext from "../../context/hooks/WebSocket";
import './style.css';

export default function TvFurnace() {
    const {
        getStatusSideBar,
    } = useContext(Context);

    return (
        <>
            <Navbar />

            <Sidebar />

            <div className={`app_body ${getStatusSideBar()}`}>
                <div className="d-flex justify-content-center flex-wrap my-5">
                    <WebsocketContext>
                        <StatusFurnace />
                    </WebsocketContext>
                </div>
            </div>
        </>
    );
}
